module.exports = __webpack_public_path__ + "static/media/terrain.f8d19f6e.jpg";